/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const BENEFITS_SEARCH = "BENEFITS_SEARCH";
export const BENEFITS_SEARCH_SUCCESS = "BENEFITS_SEARCH_SUCCESS";
export const BENEFITS_SEARCH_FAIL = "BENEFITS_SEARCH_FAIL";

export const BENEFITS_RESET = "BENEFITS_RESET";

export const UPDATE_BENEFIT_LISTING_CURRENT_PAGE = "UPDATE_BENEFIT_LISTING_CURRENT_PAGE";
export const UPDATE_BENEFIT_LISTING_PAGE_SIZE = "UPDATE_BENEFIT_LISTING_PAGE_SIZE";

export const BENEFITS_FILTER_VALUE_ADD = "BENEFITS_FILTER_VALUE_ADD";
export const BENEFITS_FILTER_VALUE_REMOVE = "BENEFITS_FILTER_VALUE_REMOVE";
export const BENEFITS_FILTER_VALUE_UPDATE = "BENEFITS_FILTER_VALUE_UPDATE";
